export default __webpack_public_path__ + "static/media/learn-english-janet-belshaw-online-English-Teacher.893c0321.webp";